import { IMachineChart, IStateTransitionConfig } from './types';

function transition<TState extends string, TAction extends string, TContext>(
  chart: IMachineChart<TState, TAction, TContext>,
  currentState: TState,
  action: TAction,
  context: TContext,
): IStateTransitionConfig<TState> {
  let nextState = chart[currentState][action as string];

  if (typeof nextState === 'function') {
    nextState = nextState(context);
  }

  if (typeof nextState === 'string') {
    return {
      state: nextState,
    };
  }

  return nextState;
}

export { transition };
